// extracted by mini-css-extract-plugin
export default {"result":"Result_result__yW8HI","refresh":"Result_refresh__cLtn6"};